<template>
  <div class="card d-print-none mb-2">
    <div class="card-body">
      <router-link :to="taskData.api_url" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" ><i class="feather icon-corner-up-left"></i> {{labels.get('label_back')}}</router-link>
      <template v-if="item.exists">
        <button  type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="save(false)"><i class="feather icon-save"></i> {{labels.get('label_save')}}</button>
      </template>
    </div>
  </div>
  <form id="formSaveItem">
    <input type="hidden" name="save_token" :value="new Date().getTime()">
    <input type="hidden" name="id" :value="item.id">
    <div id="accordion" v-if="item.exists">
      <div class="card">
        <div class="card-header p-1">
          <a class="btn btn-sm" data-toggle="collapse" href="#label_basic_info">Basic Info</a>
        </div>
        <div id="label_basic_info" class="collapse show">
          <div class="card-body row">
            <div class="col-md-3">
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Part Number <span class="text-danger">*</span></label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input id="item_part_number" type="text" class="form-control" v-model="item.data.part_number" name="item[part_number]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Category</label></div>
                <div class="col-7">
                  <input type="hidden" id="item_category_id" name="item[category_id]" v-model="item.data.category_id">
                  <span id="item_category_name">{{item.data.category_code}}</span>

                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Type</label></div>
                <div class="col-7">
                  <input type="hidden" id="item_type_id" name="item[type_id]" v-model="item.data.type_id">
                  <span id="item_type_name">{{item.data.type_code}}</span>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Description</label></div>
                <div class="col-7">
                  <div class="input-group"><textarea class="form-control" v-model="item.data.description" name="item[description]"></textarea></div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Additional Description</label></div>
                <div class="col-7">
                  <div class="input-group"><textarea class="form-control" v-model="item.data.description_additional" name="item[description_additional]"></textarea></div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Datasheet Done</label>
                </div>
                <div class="col-7">
                  <div class="input-group">
                    <select class="form-control" v-model="item.data.datasheet_done" name="item[datasheet_done]">
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Make/Buy</label>
                </div>
                <div class="col-7">
                  <div class="input-group">
                    <select class="form-control" v-model="item.data.make_buy" name="item[make_buy]">
                      <option value="">Select</option>
                      <option value="Make">Make</option>
                      <option value="Buy">Buy</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Drawing Number</label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.drawing_number" name="item[drawing_number]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Unit <span class="text-danger">*</span></label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.unit" name="item[unit]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Note</label></div>
                <div class="col-7">
                  <div class="input-group"><textarea class="form-control" v-model="item.data.note" name="item[note]"></textarea></div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row mb-2">
                <div class="col-5">
                  <label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 1</label>
                </div>
                <div class="col-7">
                  <div class="input-group" >
                    <select class="form-control" v-model="item.data.vendor1_id" name="item[vendor1_id]">
                      <option value="">{{labels.get('label_select')}}</option>
                      <option v-for="(option, i) in taskData.vendors" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Vendor 1 PN</label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.vendor1_pn" name="item[vendor1_pn]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5">
                  <label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 2</label>
                </div>
                <div class="col-7">
                  <div class="input-group" >
                    <select class="form-control" v-model="item.data.vendor2_id" name="item[vendor2_id]">
                      <option value="">{{labels.get('label_select')}}</option>
                      <option v-for="(option, i) in taskData.vendors" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Vendor 2 PN</label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.vendor2_pn" name="item[vendor2_pn]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5">
                  <label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}} 3</label>
                </div>
                <div class="col-7">
                  <div class="input-group" >
                    <select class="form-control" v-model="item.data.vendor3_id" name="item[vendor3_id]">
                      <option value="">{{labels.get('label_select')}}</option>
                      <option v-for="(option, i) in taskData.vendors" :value="option.id">
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Vendor 3 PN</label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.vendor3_pn" name="item[vendor3_pn]">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Cost <span class="text-danger">*</span></label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.cost" name="item[cost]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Service Part</label>
                </div>
                <div class="col-7">
                  <div class="input-group">
                    <select class="form-control" v-model="item.data.service_part" name="item[service_part]">
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Released</label>
                </div>
                <div class="col-7">
                  <div class="input-group">
                    <select class="form-control" v-model="item.data.released" name="item[released]">
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Release Number</label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.release_number" name="item[release_number]">
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5"><label class="font-weight-bold float-right">Revision <span class="text-danger">*</span></label></div>
                <div class="col-7">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="item.data.revision_manual" name="item[revision_manual]">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header p-1">
          <a class="btn btn-sm" data-toggle="collapse" href="#label_sub_pn">Sub Part Number </a>
        </div>
        <div id="label_sub_pn" class="collapse" :class="item.data.sub_pns_ordered.length>0?'show':'hide'">
          <div class="card-body">
            <div class="row">
              <div class="card-body" style='overflow-x:auto;height:530px;'>
                <table id="table_sub_pns" class="table table-bordered">
                  <thead class="table-active">
                  <tr>
                    <th style="width: 110px;" class="position-relative align-middle d-print-none">{{labels.get('label_action')}}</th>
                    <th style="width: 110px;">Order Number</th>
                    <th style="width: 110px;">Quantity</th>
                    <th style="width: 250px;">Part Number</th>
                    <th>Description</th>
                    <th>Additional Description</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="pn in item.data.sub_pns_ordered">
                    <tr :id="'tr_sub_pn_'+pn.id">
                      <td>
                        <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-danger btn_remove_pn"><i class="bi bi-dash-circle"></i> Remove </button>
                      </td>
                      <td>
                        <input type="text" :name="'item[sub_pns]['+[pn.id]+'][order_number]'" :value="pn.order_number" class="form-control text-right" />
                      </td>
                      <td>
                        <input type="text" :name="'item[sub_pns]['+[pn.id]+'][quantity]'" :value="pn.quantity" class="form-control text-right" />
                      </td>
                      <td>
                        <button v-if="item.data.sub_pns_info[pn.id]['sub_pns']" type="button" class="btn btn-sm bg-gradient-success but_pn_more_plus" :data-id="pn.id"><i class="feather icon-plus-circle"></i> </button>
                        <button style="display: none" v-if="item.data.sub_pns_info[pn.id]['sub_pns']" type="button" class="btn btn-sm bg-gradient-warning but_pn_more_minus" :data-id="pn.id"><i class="feather icon-minus-circle"></i> </button>
                        {{ item.data.sub_pns_info[pn.id]['part_number'] }}
                      </td>
                      <td>
                        {{ item.data.sub_pns_info[pn.id]['description'] }}
                      </td>
                      <td>
                        {{ item.data.sub_pns_info[pn.id]['description_additional'] }}
                      </td>
                    </tr>
                    <tr style="display: none;">
                      <td colspan="3">&nbsp;</td>
                      <td colspan="5">
                        <table class="table table-bordered">
                          <tbody>

                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>

                    <tr id="tr_sub_pn_add">
                      <td>
                        <button type="button" id="btn_show_sub_pn_search" class="mr-2 mb-2 btn btn-sm bg-gradient-primary"><i class="feather icon-plus-circle"></i> Add </button>
                      </td>
                      <td colspan="5">
                        <div id="container_sub_pn_search" style="display: none">
                          <div class="row ml-2 mr-2 mt-2">
                            <div class="col-md-2">
                              <div class="row">
                                <div class="col-4">
                                  <label class="font-weight-bold float-right">{{labels.get('label_category_name')}}</label>
                                </div>
                                <div class="col-8">
                                  <div class="input-group" >
                                    <select class="form-control" name="options[category_id]">
                                      <option value="">{{labels.get('label_select')}}</option>
                                      <option v-for="(option, i) in taskData.categories" :value="option.id" :selected="item.data.category_id==option.id">
                                        {{ option.code }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="row">
                                <div class="col-4">
                                  <label class="font-weight-bold float-right">{{labels.get('label_type_name')}}</label>
                                </div>
                                <div class="col-8">
                                  <div class="input-group" >
                                    <select class="form-control" name="options[type_id]">
                                      <option value="">{{labels.get('label_select')}}</option>
                                      <option v-for="(option, i) in taskData.types" :value="option.id" :selected="item.data.type_id==option.id">
                                        {{ option.code }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="row">
                                <div class="col-4">
                                  <label class="font-weight-bold float-right">{{labels.get('label_vendor_name')}}</label>
                                </div>
                                <div class="col-8">
                                  <div class="input-group" >
                                    <select class="form-control" name="options[vendor_id]">
                                      <option value="">{{labels.get('label_select')}}</option>
                                      <option v-for="(option, i) in taskData.vendors" :value="option.id">
                                        {{ option.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="row mb-2">
                                <div class="col-2">
                                  <label class="font-weight-bold float-right">Text</label>
                                </div>
                                <div class="col-10">
                                  <div class="input-group">
                                    <input id="search_text" type="text" class="form-control" name="options[text]">
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="searchSubPN"><i class="feather icon-save"></i> {{labels.get('label_search')}}</button>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="card-body" style='overflow-x:auto;height:330px;'>
                              <table class="table table-bordered">
                                <thead class="table-active">
                                <tr>
                                  <th class="position-relative align-middle d-print-none">{{labels.get('label_action')}}</th>
                                  <template v-for="(column,key) in taskData.columns.all">
                                    <th class="position-relative align-middle" v-if="taskData.columns.hidden.indexOf(key)<0" :key="'th_'+key">
                                      <ColumnSort :columns="taskData.columns" :sortKey="key" :position="'left:5px'"  :onChangeSort="setFilteredSearchedPNs" v-if="taskData.permissions.action_6 && column.sortable"/>
                                      <div class=" text-center " style="width:calc(100% - 33px);margin-left:17px">
                                        {{ column.label }}
                                      </div>
                                      <ColumnFilter :column="column" :position="'right:5px'"  :onChangeFilter="setFilteredSearchedPNs" v-if="taskData.permissions.action_6 && column.filterable"/>
                                    </th>
                                  </template>
                                </tr>
                                </thead>
                                <tbody class="table-striped table-hover">
                                <tr v-for="pn in item.searchedPNsFiltered" >
                                  <td class="col_1 d-print-none">
                                    <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-primary" @click="addSubPN(pn)"><i class="feather icon-plus-circle"></i> {{labels.get('action_1')}}</button>

                                  </td>
                                  <template v-for="(column,key) in taskData.columns.all">
                                    <td :class="((['id','ordering'].indexOf(key) != -1)?'text-right':'')+(column.class?(' '+column.class):'col_9')" v-if="taskData.columns.hidden.indexOf(key)<0" :key="'td_'+key">
                                      <template v-if="key=='part_number'">{{ pn[key] }}</template>
                                      <template v-else>{{ pn[key] }}</template>

                                    </td>
                                  </template>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script setup>

import globalVariables from "@/assets/globalVariables";
import systemFunctions from "@/assets/systemFunctions";
import toastFunctions from "@/assets/toastFunctions";
import labels from '@/labels'

import ColumnSort from '@/components/ColumnSort.vue';
import ColumnFilter from '@/components/ColumnFilter.vue';
import Pagination from '@/components/Pagination.vue';

import {useRouter} from "vue-router";
import {inject, reactive} from "vue";
import axios from "axios";
import InputTemplate from '@/components/InputTemplate.vue';
import {useRoute} from "vue-router/dist/vue-router";


const route =useRoute()
const router =useRouter()
let taskData = inject('taskData')
let item=reactive({
  id:0,
  exists:false,
  searchedPNs: {data:[]},   //from Laravel server with pagination and info
  searchedPNsFiltered: [],    //for display
  data:{
    id:0,
    part_number:'',
    category_id:'',
    category_code:'',
    type_id:'',
    type_code:'',
    description:'',
    description_additional:'',
    datasheet_done:'',
    make_buy:'',
    drawing_number:'',
    unit:'',
    note:'',
    vendor1_id:'',
    vendor1_pn:'',
    vendor2_id:'',
    vendor2_pn:'',
    vendor3_id:'',
    vendor3_pn:'',
    cost:'',
    service_part:'',
    released:'',
    release_number:'',
    revision_manual:'',
    sub_pns:{},
    sub_pns_ordered:[],
    sub_pns_info:{},
    ordering:99,
    status:'Active',
  }
})
const searchSubPN=async()=>{
  item.searchedPNs=[];
  let formData=new FormData(document.getElementById('formSaveItem'))
  formData.set('page','1')
  formData.set('perPage','-1')
  //formData.set('perPage',1)
  await axios.post(taskData.api_url+'/get-items',formData).then((res)=>{
    if (res.data.error == "") {
      item.searchedPNs=res.data.items
      setFilteredSearchedPNs();
    }
    else{
      toastFunctions.showResponseError(res.data)
    }
  });

}
const setFilteredSearchedPNs=()=>{
  item.searchedPNsFiltered=systemFunctions.getFilteredItems(item.searchedPNs.data,taskData.columns);
}
const addSubPN=async(pn)=>{
  if($('#tr_sub_pn_'+pn.id).length==0){
    let html=('<tr id="tr_sub_pn_'+pn.id+'">');
    html+=('<td> <button type="button" class="mr-2 mb-2 btn btn-sm bg-gradient-danger btn_remove_pn"><i class="bi bi-dash-circle"></i> Remove </button></td>');
    html+=('<td> <input type="text" name="item[sub_pns]['+[pn.id]+'][order_number]" value="0" class="form-control text-right" /></td>');
    html+=('<td> <input type="text" name="item[sub_pns]['+[pn.id]+'][quantity]" value="0" class="form-control text-right" /></td>');
    html+=('<td>');
    if(pn.sub_pns){
      html+=('<button type="button" class="btn btn-sm bg-gradient-success but_pn_more_plus" data-id="'+pn.id+'"><i class="feather icon-plus-circle"></i> </button>');
      html+='<button style="display: none" type="button" class="btn btn-sm bg-gradient-warning but_pn_more_minus" data-id="'+pn.id+'"><i class="feather icon-minus-circle"></i> </button>';
    }
    html+=(pn['part_number']+ '</td>');
    html+=('<td>'+(pn['description']?pn['description']:'')+ '</td>');
    html+=('<td>'+(pn['additional_description']?pn['additional_description']:'')+ '</td>');
    html+='</tr>';
    html+=('<tr style="display: none;"><td colspan="3">&nbsp;</td><td colspan="5"><table class="table table-bordered"><tbody></tbody></tbody></table></td></tr>');
    $('#tr_sub_pn_add').before(html)
  }
  console.log(pn)
}
const save=async (save_and_new)=>{
  let formData=new FormData(document.getElementById('formSaveItem'))
  await axios.post(taskData.api_url+'/save-item',formData).then((res)=>{
    if (res.data.error == "") {
      toastFunctions.showSuccessfullySavedMessage();
      if(save_and_new){
        if(item.id>0){
          router.push(taskData.api_url+"/add")
        }
        else{

        }
      }
      else{
        router.push(taskData.api_url)
      }
      taskData.reloadItems(taskData.pagination)
    }
    else{
      toastFunctions.showResponseError(res.data)
    }
  });

}
const getItem=async ()=>{
  await axios.get(taskData.api_url+'/get-item/'+ item.id).then((res)=>{
    if (res.data.error == "") {
      let itemData=res.data.item;
      for(let key in itemData){
        if(!itemData[key]){
          itemData[key]='';//setting null value to empty string
        }
      }
      item.data=itemData;
      item.exists=true;
    }
    else{
      toastFunctions.showResponseError(res.data)
    }
  });
}
$(document).ready(async function()
{
  $(document).off("input", "#item_part_number");
  $(document).on("input", "#item_part_number", function(event)
  {
    let part_number=$(this).val();
    let first_pos=part_number.indexOf('-')
    item.data.category_id=0;
    item.data.category_code='NF';
    item.data.type_id=0;
    item.data.type_code='NF';
    if(first_pos>0){
      let category_code=part_number.substring(0,first_pos);
      let category = taskData.categories.find(obj => obj.code === category_code);
      if(category){
        item.data.category_code=category.code;
        item.data.category_id=category.id;
      }
      let last_pos=part_number.lastIndexOf('-')
      if(last_pos>first_pos){
        let type_code=part_number.substring(last_pos+1);
        let type = taskData.types.find(obj => obj.code === type_code);
        if(type){
          item.data.type_code=type.code;
          item.data.type_id=type.id;
        }
      }
    }
  });
  $(document).off("click", ".btn_remove_pn");
  $(document).on("click",'.btn_remove_pn',function(){
    $(this).closest('tr').next().remove();
    $(this).closest('tr').remove();
  });
  $(document).off("click", "#btn_show_sub_pn_search");
  $(document).on("click", '#btn_show_sub_pn_search', function () {
    $('#container_sub_pn_search').toggle();
  })
  $(document).off("click", ".but_pn_more_minus");
  $(document).on("click", '.but_pn_more_minus',async function () {

    $(this).closest('tr').next().find('tbody').html('')
    $(this).closest('tr').next().hide();
    $(this).hide();
    $(this).siblings('.but_pn_more_plus').show();
  })
  $(document).off("click", ".but_pn_more_plus");
  $(document).on("click", '.but_pn_more_plus',async function () {
    let but=$(this);
    let pn_id=$(this).attr('data-id')
    await axios.get(taskData.api_url+'/get-item/'+ pn_id).then((res)=>{
      if (res.data.error == "") {
        let sub_pns_ordered=res.data.item.sub_pns_ordered;
        let sub_pns_info=res.data.item.sub_pns_info;
        let html='';
        for(let index in sub_pns_ordered){
          let sub_pn=sub_pns_ordered[index];
          html+=('<tr>');
          html+=('<td style="width: 110px;" class="text-right"> '+sub_pn['order_number']+'</td>');
          html+=('<td style="width: 110px;" class="text-right"> '+sub_pn['quantity']+'</td>');
          html+=('<td style="width: 250px;">');
          if(sub_pns_info[sub_pn['id']].sub_pns){
            html+=('<button type="button" class="btn btn-sm bg-gradient-success but_pn_more_plus" data-id="'+sub_pn.id+'"><i class="feather icon-plus-circle"></i> </button>');
            html+='<button style="display: none" type="button" class="btn btn-sm bg-gradient-warning but_pn_more_minus" data-id="'+sub_pn.id+'"><i class="feather icon-minus-circle"></i> </button>';
          }
          html+=(sub_pns_info[sub_pn['id']]['part_number']+ '</td>');
          html+=('<td>'+(sub_pns_info[sub_pn['id']]['description']?sub_pns_info[sub_pn['id']]['description']:'')+ '</td>');
          html+=('<td>'+(sub_pns_info[sub_pn['id']]['additional_description']?sub_pns_info[sub_pn['id']]['additional_description']:'')+ '</td>');
          html+=('</tr>');
          html+=('<tr style="display: none;"><td colspan="2">&nbsp;</td><td colspan="5"><table class="table table-bordered"><tbody></tbody></tbody></table></td></tr>');
        }
        but.closest('tr').next().find('tbody').html(html)
        but.closest('tr').next().show();
        $(this).hide();
        $(this).siblings('.but_pn_more_minus').show();


      }
      else{
        toastFunctions.showResponseError(res.data)
      }
    });


  })

})
  item.id=route.params['item_id']?route.params['item_id']:0;
  if(item.id>0){
    if(!(taskData.permissions.action_2)){
      toastFunctions.showAccessDenyMessage();
    }
    else{
      getItem();
    }
  }
  else{
    if(!(taskData.permissions.action_1)){
      toastFunctions.showAccessDenyMessage();
    }
    else{
      item.exists=true;
    }
  }

</script>